<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-alert
        prominent
        type="error"
        v-if="error"
        transition="scroll-y-transition"
      >
        <v-row align="center">
          <v-col class="grow">
            Es ist ein unerwarteter fehler aufgetretet...
          </v-col>
        </v-row>
      </v-alert>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="green darken-1" dark flat>
            <v-toolbar-title>Login form</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Login"
                name="login"
                prepend-icon="mdi-account"
                type="text"
                v-model="user.email"
                autocomplete="username"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                v-model="user.password"
                autocomplete="current-password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="login()">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from '../lib/api';
import store from '../store/index';
import socket from '../lib/socket';

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      error: false,
    };
  },
  computed: {
    ...mapGetters({
      user1: 'user',
    }),
  },
  methods: {
    login() {
      const t = this;
      axios
        .post('/user', {
          email: this.user.email.trim().toLowerCase(),
          password: this.user.password,
        })
        .then(
          (res) => {
            store.commit('SET_LOGGED_IN', true);
            store.commit('SET_USER', res.data);
            socket.emit('login', res.data);
            t.error = false;
            if (this.$route.query.redirect) {
              this.$router.push({ path: this.$route.query.redirect });
            } else {
              this.$router.push({ path: 'leads' });
            }
          },
          (err) => {
            if (err.response.status === 401) {
              store.commit('SET_LOGGED_IN', false);
              t.error = true;
            }
          }
        );
    },
  },
};
</script>
